/**
 * @fileoverview The i18next namespace the phone input's bundles register under.
 * @package @puffin-core/phone-ui
 *
 * A ZERO-IMPORT leaf module, deliberately: `usePhoneUiTranslate()` imports it, and routing the constant
 * through `strings/index.js` would drag `en.js` and `es.js` into every component's import chain for one
 * short string.
 *
 * JSDOC-PROP-CONTRACT-001 PACKAGE-I18N-SEAT U3 (2026-10-23) — namespace #51, issued by the coordinator.
 *
 * @module @puffin-core/phone-ui/strings/namespace
 */

/** The canonical namespace under which the phone input's strings live in i18next. */
export const PHONE_UI_NAMESPACE = 'phoneUi';

export default PHONE_UI_NAMESPACE;
